import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Tabs } from "antd";
import React, { useState } from "react";
import CustomHeader from "../common/Header";
import Team from "./Team";
import Shift from "./Shift";
import Member from "./Member";
import "./style.css";
import Schedule from "./Schedule";

const TeamMangementContext = React.createContext();

const { TabPane } = Tabs;

function TeamManagement() {
    const [activeTab, setActiveTab] = useState("team");
    const [teamFormVisible, setTeamFormVisible] = useState(false);
    const [memberFormVisible, setMemberFormVisible] = useState(false);
    const [shiftFormVisible, setShiftFormVisible] = useState(false);
    const context = {
        teamFormVisible,
        memberFormVisible,
        shiftFormVisible,
        setTeamFormVisible,
        setMemberFormVisible,
        setShiftFormVisible,
    };

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <div className="add-element-buttons-container flex justify-end gap-3">
                <Button
                    className="add-element-buttons"
                    type="primary"
                    onClick={() => {
                        setActiveTab("team");
                        setTeamFormVisible(true);
                    }}
                >
                    <PlusOutlined /> Team
                </Button>
                <Button
                    className="add-element-buttons"
                    type="primary"
                    onClick={() => {
                        setActiveTab("member");
                        setMemberFormVisible(true);
                    }}
                >
                    <PlusOutlined /> Member
                </Button>
                <Button
                    className="add-element-buttons"
                    type="primary"
                    onClick={() => {
                        setActiveTab("shift");
                        setShiftFormVisible(true);
                    }}
                >
                    <PlusOutlined /> Shift
                </Button>
            </div>

            <TeamMangementContext.Provider value={context}>
                <Tabs
                    type="card"
                    destroyOnHidden={true}
                    activeKey={activeTab}
                    onChange={(key) => {
                        setActiveTab(key);
                    }}
                >
                    <TabPane key="team" tab="Teams">
                        <Team />
                    </TabPane>
                    <TabPane key="member" tab="Members">
                        <Member />
                    </TabPane>
                    <TabPane key="shift" tab="Shifts">
                        <Shift />
                    </TabPane>
                    <TabPane key="calender" tab="Schedule">
                        <Schedule />
                    </TabPane>
                </Tabs>
            </TeamMangementContext.Provider>
        </Card>
    );
}

export { TeamMangementContext };
export { TeamManagement };
